import { render, staticRenderFns } from "./FulltextSearch.vue?vue&type=template&id=b3c89c64&"
import script from "./FulltextSearch.vue?vue&type=script&lang=js&"
export * from "./FulltextSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports